import React, { useEffect, useState, useCallback } from 'react';
import { hiddenService } from '../api';
import AdCard from './AdCard';
import './AdCard.css';
import './FavoritesList.css';
import './HiddenList.css';

const SUB_TABS = [
    { id: 'ads',     label: 'Объявления' },
    { id: 'sellers', label: 'Пользователи' },
];

function HiddenSellerRow({ seller, onRestore }) {
    const [busy, setBusy] = useState(false);

    const handleRestore = async () => {
        if (busy) return;
        setBusy(true);
        try {
            await hiddenService.unhideSeller(seller.userId);
            onRestore(seller.userId);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="hidden-seller-row">
            <div className="hidden-seller-row__avatar">
                {seller.avatarUrl ? (
                    <img src={seller.avatarUrl} alt={seller.name} />
                ) : (
                    seller.name?.charAt(0).toUpperCase()
                )}
            </div>
            <span className="hidden-seller-row__name">{seller.name}</span>
            <button className="hidden-seller-row__restore" onClick={handleRestore} disabled={busy}>
                Показать
            </button>
        </div>
    );
}

const HiddenList = () => {
    const [subTab, setSubTab] = useState('ads');

    const [ads, setAds] = useState([]);
    const [adsLoading, setAdsLoading] = useState(true);
    const [adsError, setAdsError] = useState(null);

    const [sellers, setSellers] = useState([]);
    const [sellersLoading, setSellersLoading] = useState(true);
    const [sellersError, setSellersError] = useState(null);

    const loadAds = useCallback(() => {
        setAdsLoading(true);
        setAdsError(null);
        hiddenService.getHiddenAds()
            .then(({ data }) => setAds(data))
            .catch(() => setAdsError('Не удалось загрузить скрытые объявления.'))
            .finally(() => setAdsLoading(false));
    }, []);

    const loadSellers = useCallback(() => {
        setSellersLoading(true);
        setSellersError(null);
        hiddenService.getHiddenSellers()
            .then(({ data }) => setSellers(data))
            .catch(() => setSellersError('Не удалось загрузить скрытых пользователей.'))
            .finally(() => setSellersLoading(false));
    }, []);

    useEffect(() => { loadAds(); loadSellers(); }, [loadAds, loadSellers]);

    const handleAdRestored = (adId) => setAds(prev => prev.filter(a => a.id !== adId));
    const handleSellerRestored = (userId) => setSellers(prev => prev.filter(s => s.userId !== userId));

    return (
        <div className="hidden-list">
            <div className="hidden-list__subtabs">
                {SUB_TABS.map(tab => (
                    <button
                        key={tab.id}
                        className={`hidden-list__subtab${subTab === tab.id ? ' hidden-list__subtab--active' : ''}`}
                        onClick={() => setSubTab(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {subTab === 'ads' ? (
                adsLoading ? (
                    <div className="profile-content__placeholder">Загрузка...</div>
                ) : adsError ? (
                    <div className="profile-content__placeholder">{adsError}</div>
                ) : ads.length === 0 ? (
                    <div className="profile-content__placeholder">Скрытых объявлений нет.</div>
                ) : (
                    <div className="favorites-grid">
                        {ads.map(ad => (
                            <AdCard key={ad.id} ad={ad} view="grid" restoreMode onRestore={handleAdRestored} />
                        ))}
                    </div>
                )
            ) : (
                sellersLoading ? (
                    <div className="profile-content__placeholder">Загрузка...</div>
                ) : sellersError ? (
                    <div className="profile-content__placeholder">{sellersError}</div>
                ) : sellers.length === 0 ? (
                    <div className="profile-content__placeholder">Скрытых пользователей нет.</div>
                ) : (
                    <div className="hidden-sellers-list">
                        {sellers.map(seller => (
                            <HiddenSellerRow key={seller.userId} seller={seller} onRestore={handleSellerRestored} />
                        ))}
                    </div>
                )
            )}
        </div>
    );
};

export default HiddenList;
